<template>
  <div>
    <Equipment
      :inspection-config="inspectionConfig"
      :filter-params="filterParams"
      :extra-equipment-text="extraEquipmentText"
      :initial-filters="initialFilters"
    />
    <Snackbar :type="notification" :text="errorMessage" @onClose="handleSnackbarClose" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import get from 'lodash/get';
import MetricController from '@/controllers/MetricController';
import { Snackbar, notificationType } from '@/components/widgets';
import Equipment from './Equipment.vue';

export default {
  name: 'EquipmentContainer',
  components: {
    Equipment,
    Snackbar,
  },
  data() {
    return {
      initialFilters: undefined,
      errorMessage: undefined,
      notification: notificationType.none,
    };
  },
  computed: mapGetters({
    filterParams: 'config/filterParams',
    inspectionConfig: 'config/inspectionConfig',
    extraEquipmentText: 'config/clientExtraEquipmentText',
    extrenalFilterParams: 'config/extrenalFilterParams',
  }),
  async created() {
    if (this.$route.query.source === 'external') {
      const { system, tag, id } = this.$route.query;
      const { data, error } = await MetricController.getExternalSystem(id, system, tag);
      if (error) {
        this.handleError(error);
      } else {
        this.initialFilters = [{ key: 'meta.AutoCad:LineKey', value: get(data, 'tagName') }];
      }
    } else {
      // Needed to render the graphs when there is no source query
      this.$nextTick(() => {
        this.initialFilters = [];
      });
    }
  },
  methods: {
    handleError(message) {
      this.errorMessage = message;
      this.notification = notificationType.error;
    },
    handleSnackbarClose() {
      this.notification = notificationType.none;
    },
  },
};
</script>
